import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {TransactionSummaryDoughnutChartCard} from '@/components/composite'
import {EcomTransactionSummaryDoughnutChartCardStoreType} from '@/pages/Reports/components'
import {TSelectContainerStore} from '@/components/containers'

export const IssuerStoreSymbol = Symbol('IssuerStoreSymbol')
export const IssuerStatusStoreSymbol = Symbol('IssuerStatusStore')

export const IssuerDoughnutChartContainer = observer(() => {
    const { t } = useTranslation()
    const store = useInjection<EcomTransactionSummaryDoughnutChartCardStoreType>(IssuerStoreSymbol)
    const selectStore = useInjection<TSelectContainerStore>(IssuerStatusStoreSymbol)

    return (
        <TransactionSummaryDoughnutChartCard
            tooltipText={t('Reports.issuingBanks')}
            amountData={store.amountData}
            countData={store.countData}
            tabType={store.chartType}
            setChartType={store.setChartTabType}
            title={t('Reports.issuingBanks')}
            centerTitle={t('Reports.volumeTotal')}
            selectStatusProps={{
                value: selectStore.value,
                options: selectStore.options,
                onChange: selectStore.setValue
            }}
            loadingState={store.amountLoadingState}
            currency={store.currency}
        />
    )
})
